"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, Separator } from "@opensea/ui-kit";
import dynamic from "next/dynamic";
import { useState } from "react";
import { Notifications } from "@/components/notifications/Notifications";
import { useAddress } from "@/hooks/wallet";
import { AccountSwitcherDropdown } from "./account-switcher/AccountSwitcherDropdown";
import { ProfileButton } from "./ProfileButton";
import { SwapIconButton } from "./SwapIconButton";
import { TopNavConnectButton } from "./TopNavConnectButton";
const TreasureChestNavigationClient = dynamic(() => import("./TreasureChestNavigation").then(value => value.TreasureChestNavigation), {
  ssr: false
});
export function UserControls() {
  const $ = _c(15);
  const address = useAddress();
  const [accountSwitcherOpen, setAccountSwitcherOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TreasureChestNavigationClient />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== address) {
    t1 = <TopNavConnectButton address={address} className="px-4" />;
    $[1] = address;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Separator className="h-6" orientation="vertical" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== address) {
    t3 = address ? <><Notifications /><Separator className="h-6" orientation="vertical" /><SwapIconButton /><Separator className="h-6" orientation="vertical" /></> : null;
    $[4] = address;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = address ? undefined : false;
  let t5;
  if ($[6] !== accountSwitcherOpen) {
    t5 = <div><ProfileButton dropdownOpen={accountSwitcherOpen} /></div>;
    $[6] = accountSwitcherOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <AccountSwitcherDropdown onOpenChange={setAccountSwitcherOpen} open={t4}>{t5}</AccountSwitcherDropdown>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t6) {
    t7 = <FlexCenter className="shrink-0 gap-1">{t0}{t1}{t2}{t3}{t6}</FlexCenter>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}